













import Vue from 'vue';
import { BACKEND_URL } from '../constants';
import { MinichatLine } from '../itemtypes';
import ViewItem from '@/components/ViewItem.vue';
import qs from 'qs';

const PROMPTS = [
    "Amaze the world!",
    "But make it good.",
    "You can do it!",
    "GWTP values your feedback.",
    "Or here. Or here.",
    "I double dog dare you.",
    "If, like, you want to.",
    "Pleeease? Pretty please?",
    "Like the prophecy foretold…",
    "Share your life story.",
    "Введите что-то здесь.",
];

export default Vue.extend({

    components: {
        ViewItem,
    },

    computed: {
        lines(): MinichatLine[] {
            return this.$store.state.minichatLines;
        },
    },

    data() {
        return {
            input: '',
            placeholder: '',
        };
    },

    watch: {
        lines() {
            //const el = document.getElementById('minichat');
            this.scrollToBottom(); //if (el) el.scrollTop = 10000;
        }
    },

    mounted() {
        this.$store.dispatch('loadMinichat');
        this.placeholder = this.randomPrompt();
    },

    methods: {
        randomPrompt(): string {
            const i = Math.floor(Math.random() * PROMPTS.length);
            const msg = PROMPTS[i];
            return `Type something here. ${msg}`;
        },
        
        post(): void {
            this.$store.dispatch('postToMinichat', { message: this.input });
            this.input = '';
            this.placeholder = '';
        },

        scrollToBottom(): void {
            const m = document.getElementById('minichat');
            window.setTimeout(() => {
                if (m)
                    m.scrollTop = 10000;
            }, 100);
        },

        userName(line: any): string {
            return line.poster.name;
        },
    }

});

